export const types: string[] = [
  'image/bmp',
  'image/jpeg',
  'image/jpg',
  'image/png'
];
